import * as propertyTypes from "../property_types.js"

export class UiDynamicProps extends propertyTypes.AppBaseComponentProps {

    private moduleNameMetadata = new propertyTypes.TextProperty("moduleName", "Module name");
    public moduleName: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMeta = super.getMetadata();
        this.metadataAll = baseMeta.concat([this.moduleNameMetadata]);

    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}